/**
 * @file ShopsAccess.tsx
 * @description Доступ к разделу «Магазины» (phase19.28 этап А;
 * uiux-platform-shops §7 «Права»): без `PLATFORM_MANAGE_SHOPS` пункта меню
 * нет, а по прямому адресу — понятный текст вместо перехода на /403. API
 * всё равно отвечает 403. Тот же приём — `ConsentTextsAccess`.
 *
 * `permission` — для вкладок карточки с другим правом («Интеграции»,
 * «Доступ»): заголовок и пояснение задаёт вкладка.
 */

import { ShieldAlert } from "lucide-react";
import { Outlet, useOutletContext } from "react-router";

import { useHasPermission } from "../../../auth/hooks";
import { SHOPS_PERMISSION } from "../../../lib/api-platform-shops";
import { EmptyState } from "../../ui/EmptyState";

interface Props {
  permission?: string;
  title?: string;
  description?: string;
}

export function ShopsAccess({
  permission = SHOPS_PERMISSION,
  title = "Нет доступа к магазинам платформы",
  description = "Магазины и их адреса ведёт администратор платформы с правом «Управление магазинами».",
}: Props) {
  const allowed = useHasPermission(permission);
  // Вложенный <Outlet> не наследует контекст родительского: пробрасываем
  // контекст карточки магазина (useShopCardContext) дальше во вкладки.
  const outletContext = useOutletContext<unknown>();
  if (allowed) return <Outlet context={outletContext} />;
  return <EmptyState icon={ShieldAlert} variant="forbidden" title={title} description={description} />;
}
